// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

// ** Handle User Login
export const handleLogin = data => {
  localStorage.setItem('userData', JSON.stringify(data))  
  return dispatch => {
    dispatch({
      type: 'LOGIN',
      data,
      config,
      [config.storageTokenKeyName]: data[config.storageTokenKeyName],
      [config.storageRefreshTokenKeyName]: data[config.storageRefreshTokenKeyName]
    })
    // ** Add to user, accessToken & refreshToken to localStorage        
    localStorage.setItem("usertoken", data.accessToken)
    localStorage.setItem(config.storageTokenKeyName, JSON.stringify(data.accessToken))    
    //save Data Array Login

    if(data.saveAccount){
      let accountlist = []
      try{
        accountlist =  JSON.parse(localStorage.getItem("listAcc"))
      }catch{accountlist = []}

      (!accountlist) && (accountlist = []) 
      accountlist.map((e,index) =>{
        if(e["userData"]["user"]["_id"] == data["user"]["_id"]){           
          accountlist.splice(index, 1)
        }
      })
      
      
      accountlist.push({        
        code_token: localStorage.getItem('code_token'),
        accessToken: JSON.stringify(data.accessToken),
        app: localStorage.getItem('app'),
        appicon: localStorage.getItem('appicon'),
        playground: localStorage.getItem('playground'),
        usertoken: data.accessToken,
        userData: data,
        instanceData: JSON.parse(localStorage.getItem('instanceData'))
      })      
      localStorage.setItem("listAcc", JSON.stringify(accountlist))      
      
    }
  }
}

export const handleCode = data => {
  localStorage.setItem('code_token', data.token)
  localStorage.setItem('app', data.app)    
  localStorage.setItem('appicon', data.icon)
  localStorage.setItem('playground', data.name)

  return dispatch => {
    dispatch({
      type: 'CODEVERY',
      data      
    })
  }
}

// ** Handle User Logout
export const handleLogout = (tipo) => {  
  return dispatch => {
    dispatch({ type: 'LOGOUT', [config.storageTokenKeyName]: null, [config.storageRefreshTokenKeyName]: null })

    if(tipo == "add"){      
      localStorage.removeItem('code_token')
    }
    if(tipo == "remove"){    
      const datauserLogged = JSON.parse(localStorage.getItem('userData'))  
      let accountlist = []
      try{
        accountlist =  JSON.parse(localStorage.getItem("listAcc"))
      }catch{accountlist = []}
      (!accountlist) && (accountlist = [])      
      accountlist.map((e,index) =>{
        
        if(e["userData"]["user"]["_id"] == datauserLogged["user"]["_id"]){  
          accountlist.splice(index, 1)
        }
      })
      localStorage.setItem("listAcc", JSON.stringify(accountlist))  
    }
    // ** Remove user, accessToken & refreshToken from localStorage   
    localStorage.removeItem('userData')
    localStorage.removeItem("workplan_filter_v1")
    localStorage.removeItem("workplan_engine_v1")
    // localStorage.removeItem('playground')
    localStorage.removeItem(config.storageTokenKeyName)
    localStorage.removeItem(config.storageRefreshTokenKeyName)
  }
}
